export default __webpack_public_path__ + "static/media/externalauth.c869f45e.svg";